/**
 * Colors theme values.
 */

import { Colors } from "@oui/system/colors"

type RedwoodColors =
  | "warmReds"
  | "oranges"
  | "greens"
  | "coolGreens"
  | "teals"
  | "blues"
  | "purples"
  | "warmPurples"

const colors: Colors<RedwoodColors> = {
  warmReds: ["#fa866f", "#f76f5a", "#ee644f", "#e55844", "#c54a39", "#a43c2e"],
  oranges: ["#fadb87", "#f4bf6f", "#eea357", "#e28541", "#d6682b", "#bb501c"],
  greens: ["#9ed689", "#8dc888", "#7bb278", "#6a9d67", "#588757", "#467146"],
  coolGreens: [
    "#94c4b2",
    "#83b5a4",
    "#6c9c8b",
    "#558271",
    "#3d6958",
    "#264f3e"
  ],
  teals: ["#86dec3", "#65ceb5", "#4eb5a3", "#389c91", "#21837F", "#0a6a6d"],
  blues: ["#7dd1d3", "#6bc0c6", "#56a7af", "#428d98", "#2d7480", "#185a69"],
  purples: ["#c1a3c7", "#b191b5", "#a17fa3", "#8a6988", "#72536d", "#5b3d51"],
  warmPurples: [
    "#e69B95",
    "#e28686",
    "#c87477",
    "#ae6169",
    "#944f5a",
    "#7a3c4b"
  ],
  grays: [
    "#f8f7f4",
    "#eceae5",
    "#dedad6",
    "#d1ccc7",
    "#70665e",
    "#57504a",
    "#3f3a36",
    "#312d2a",
    "#211f1c"
  ],
  black: "#1a1816",
  white: "#fcfbfa"
}

export default colors
